import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=4f774d2a&scoped=true";
import script from "./Regist.vue?vue&type=script&lang=js";
export * from "./Regist.vue?vue&type=script&lang=js";
import style0 from "./Regist.vue?vue&type=style&index=0&id=4f774d2a&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4f774d2a", null);
export default component.exports;